import { memo, CSSProperties, useRef } from 'react';
import { useAsyncFn } from 'react-use';
import classNames from 'classnames';
import { IonIcon } from '@ionic/react';

import { ICONS_BASE64 } from '../Icon';

import styles from './Video.module.scss';

export interface VideoProps {
  poster: string;
  video?: string;
  className?: string;
  aspectRatio?: CSSProperties['aspectRatio'];
}

export const Video = memo<VideoProps>(
  ({ poster, video, aspectRatio = 1, className }) => {
    const rootRef = useRef<HTMLDivElement>();
    const videoRef = useRef<HTMLVideoElement>();

    const [{ value: isPlaying }, handleOnPlayPause] = useAsyncFn(async () => {
      if (videoRef.current && videoRef.current.paused) {
        await videoRef.current.play();
        return true;
      }
      if (videoRef.current && !videoRef.current.paused) {
        await videoRef.current.pause();
        return false;
      }
      return false;
    });

    return (
      <div
        ref={rootRef}
        className={classNames(styles.root, className)}
        style={{ aspectRatio }}
        onClick={handleOnPlayPause}
      >
        {video && (
          <video
            playsInline
            ref={videoRef}
            preload="metadata"
            className={classNames(styles.video, {
              [styles.isPlaying]: isPlaying,
            })}
          >
            <source src={video} type="video/mp4"></source>
          </video>
        )}
        {video && (
          <button className={styles.action}>
            <IonIcon
              icon={isPlaying ? ICONS_BASE64['pause'] : ICONS_BASE64['play']}
            />
          </button>
        )}
        <img
          src={poster}
          alt=""
          className={classNames(styles.poster, {
            [styles.isPlaying]: isPlaying,
          })}
        />
      </div>
    );
  }
);
